var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":true,"width":"600px","center":true},on:{"close":_vm.close}},[_c('iframe',{staticClass:"agreement",attrs:{"title":"协议","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }